export default __webpack_public_path__ + "static/media/equity.4d3114b5.png";